/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import input from '@salesforce/retail-react-app/app/theme/components/base/input'

const mdSize = {height: 11, borderRadius: 'base'}

input.sizes = {
    ...input.sizes,
    md: {
        field: {...mdSize, px: 3},
        addon: mdSize
    }
}

input.variants = {
    ...input.variants,
    filled: {
        field: {
            ...input.variants.filled?.field,
            borderRadius: '10px',
            backgroundColor: 'gray.50',
            fontFamily: 'body',
            fontSize: '12px'
        }
    }
}

export default input
